import React, { useState } from "react";
import { Text, TouchableOpacity, View, StatusBar } from "react-native";
import { connect } from "react-redux";
import { setUserFilter } from "../actions/filter";
import { STYLES } from "../assets/styles";
import CustomIcon from "../components/CustomIcon";

function Sidebar({ navigation, filterOptions, userOption, setUserFilter }) {
  const [selectedData, setSelectedData] = useState({
    class: userOption.itemsFilter.class,
    catagories: userOption.itemsFilter.catagories,
  });

  const handleOnClose = () => {
    if (
      JSON.stringify(selectedData) !== JSON.stringify(userOption.itemsFilter)
    ) {
      setUserFilter({
        itemsFilter: selectedData,
      });
    }
    navigation.toggleDrawer();
  };

  const handleItemSelect = (name) => {
    const selectedclass = selectedData.class;
    const catagories = { ...selectedData["catagories"] };
    if (catagories[name] === undefined) {
      catagories[name] = 1;
      setSelectedData({
        class: selectedclass,
        catagories: catagories,
      });
    } else {
      if (Object.keys(catagories).length > 1) {
        delete catagories[name];
        setSelectedData({
          class: selectedclass,
          catagories: catagories,
        });
      }
    }
  };

  const catagoryItems = filterOptions.catagories[selectedData.class] || [];
  const Item = ({ text, selected, onPress = () => {} }) => (
    <TouchableOpacity onPress={() => onPress(text)}>
      <View
        style={{
          margin: 10,
          padding: 15,
          minWidth: 80,
          borderWidth: 2,
          borderColor: selected
            ? STYLES.colors.purpel
            : STYLES.colors.lightFontColor,
          justifyContent: "center",
          alignItems: "center",
          borderRadius: 5,
          backgroundColor: selected
            ? STYLES.colors.purpel + "30"
            : STYLES.colors.white,
        }}
      >
        <Text
          style={{
            color: selected
              ? STYLES.colors.purpel
              : STYLES.colors.lightFontColor,
          }}
        >
          {text}
        </Text>
      </View>
    </TouchableOpacity>
  );
  return (
    <View style={{ flex: 1, padding: 10, paddingTop: StatusBar.currentHeight }}>
      <CustomIcon
        name="left"
        type="AntDesign"
        style={{ alignSelf: "flex-end" }}
        onPress={handleOnClose}
      />
      <View style={{ flex: 1 }}>
        <View
          style={{
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-between",
            alignItems: "flex-end",
            // height: "10%",
            paddingBottom: 30,
          }}
        >
          {filterOptions.classes.map((name, index) => (
            <Item
              key={index}
              text={name}
              selected={name === selectedData.class}
              onPress={() => {
                if (selectedData.class !== name) {
                  setSelectedData({
                    class: name,
                    catagories: { [filterOptions.catagories[name][0]]: 1 },
                  });
                }
              }}
            />
          ))}
        </View>
        <View
          style={{
            borderTopWidth: 1,
            paddingTop: 30,
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-between",
          }}
        >
          {catagoryItems.map((name, index) => (
            <Item
              key={index}
              text={name}
              selected={selectedData["catagories"][name]}
              onPress={handleItemSelect}
            />
          ))}
        </View>
      </View>
    </View>
  );
}
const mapStateToProps = (state) => ({
  filterOptions: state.filter.options,
  userOption: state.filter.userOption,
});
const mapDispatchToProps = (dispatch) => ({
  setUserFilter: (data) => dispatch(setUserFilter(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
